module.exports = __webpack_public_path__ + "img/service1.c2f221a0.jpg";